var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCannotApply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Can_t_Apply",
    "data-name": "Can't Apply",
    transform: "translate(-908 -401)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(908 401)",
    fill: "#ffdbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(934.25 441.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10495",
    "data-name": "Path 10495",
    d: "M14.792,15.373,24.146,4.652a3.008,3.008,0,0,1,4.537,0l9.354,10.721,8.926-5.637a3.01,3.01,0,0,1,4.579,3.022L47.3,39.262a4.263,4.263,0,0,1-4.209,3.591H9.738a4.263,4.263,0,0,1-4.209-3.591l-4.242-26.5A3.01,3.01,0,0,1,5.867,9.737ZM4.93,13.3,9,38.707a.752.752,0,0,0,.742.634H43.091a.752.752,0,0,0,.742-.634L47.9,13.3l-8.35,5.272a3.012,3.012,0,0,1-3.876-.564L26.415,7.393,17.157,18.007a3.012,3.012,0,0,1-3.876.564Z",
    transform: "translate(-0.665 -3.035)",
    fill: "#ff4040",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7324_-_Outline",
    "data-name": "Path 7324 - Outline",
    d: "M26.75,3.37A3.593,3.593,0,0,1,29.459,4.6l9.024,10.343,8.5-5.369a3.6,3.6,0,0,1,5.469,3.61l-4.242,26.5a4.826,4.826,0,0,1-4.787,4.084H10.073a4.826,4.826,0,0,1-4.787-4.084l-4.242-26.5a3.6,3.6,0,0,1,5.469-3.61l8.5,5.369L24.04,4.6A3.593,3.593,0,0,1,26.75,3.37Zm11.511,13.1-9.684-11.1a2.423,2.423,0,0,0-3.654,0l-9.684,11.1-9.35-5.9A2.425,2.425,0,0,0,2.2,13L6.442,39.5a3.661,3.661,0,0,0,3.631,3.1H43.426a3.661,3.661,0,0,0,3.631-3.1L51.3,13a2.426,2.426,0,0,0-3.689-2.434ZM26.75,6.838l9.7,11.119a2.426,2.426,0,0,0,3.123.454l9.445-5.963L44.746,39.135a1.332,1.332,0,0,1-1.32,1.127H10.073a1.332,1.332,0,0,1-1.32-1.127L4.483,12.449l9.445,5.963a2.426,2.426,0,0,0,3.123-.454ZM38.278,19.957a3.6,3.6,0,0,1-2.71-1.23L26.75,8.619,17.933,18.727a3.6,3.6,0,0,1-4.63.674l-7.255-4.58L9.909,38.95a.166.166,0,0,0,.164.142H43.426a.167.167,0,0,0,.164-.142l3.861-24.129L40.2,19.4A3.586,3.586,0,0,1,38.278,19.957Z",
    transform: "translate(-1 -3.37)",
    fill: "#ff4040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10496",
    "data-name": "Path 10496",
    d: "M42.6,15.129a1.756,1.756,0,1,1,0,3.511H4.969a1.756,1.756,0,1,1,0-3.511Z",
    transform: "translate(1.968 12.397)",
    fill: "#ff4040",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7325_-_Outline",
    "data-name": "Path 7325 - Outline",
    d: "M5.3,14.879H42.931a2.341,2.341,0,1,1,0,4.682H5.3a2.341,2.341,0,1,1,0-4.682ZM42.931,18.39a1.17,1.17,0,1,0,0-2.341H5.3a1.17,1.17,0,1,0,0,2.341Z",
    transform: "translate(1.633 12.062)",
    fill: "#ff4040"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7819",
    "data-name": "Group 7819",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_899",
    "data-name": "Line 899",
    x2: 24.748,
    transform: "translate(951.25 417.75) rotate(45)",
    fill: "none",
    stroke: "#ff4040",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_900",
    "data-name": "Line 900",
    x2: 24.748,
    transform: "translate(968.75 417.75) rotate(135)",
    fill: "none",
    stroke: "#ff4040",
    strokeWidth: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannotApply);
export default __webpack_public_path__ + "static/media/cannot-apply.511f2918698874149eb155c268baf440.svg";
export { ForwardRef as ReactComponent };